module.exports = "/assets/27df5977050a719a224020fbabbbe9b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/SG.png
// module id = 1820
// module chunks = 0